import { styles } from './template.scss';
import { styles as commonStyles } from '../../assets/common.scss';
import {FontSizes, LineHeights} from "../../types/common/types";
import {ButtonColors} from "../../ui/gzButton/types";
import {SpinnerWidth} from "../../ui/gzProgressSpinner/types";

export const templateIzIntegration = document.createElement('template');

templateIzIntegration.innerHTML = `
  <style>${commonStyles}</style>
  <style>${styles}</style>

  <div class='wrapper'>
    <div class='customer-wrapper'>
        <gz-banner>
          <gz-progress-spinner spinnerWidth='${SpinnerWidth.LARGE}'></gz-progress-spinner>

          <div id='banner-content' class='sub-wrapper'>
            <gz-icon id="iz-icon" size="200"></gz-icon>
            <gz-text id='create-text' lineHeight='${LineHeights.SMALL}' fontSize='${FontSizes.HEADING_5}'></gz-text>
            <gz-button id='console-button' color='${ButtonColors.PRIMARY}'></gz-button>
            <gz-button id='learn-more' color='${ButtonColors.SECONDARY}'></gz-button>
          </div>
        </gz-banner>
    </div>
  </div>
`;
